module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-width": 200,
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-badge', {
          attrs: {
            "color": "info",
            "right": "",
            "overlap": ""
          },
          scopedSlots: _vm._u([{
            key: "badge",
            fn: function() {
              return [(_vm.selected && _vm.selected.length > 0) ? _c('span', {
                domProps: {
                  "textContent": _vm._s(_vm.selected.length)
                }
              }) : _vm._e()]
            },
            proxy: true
          }], null, true)
        }, [_vm._v(" "), _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "dark": "",
            "outline": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          staticClass: "mr-2"
        }, [_vm._v(_vm._s(_vm.ctaIcon))]), _vm._v("\n          " + _vm._s(_vm.cta) + "\n        ")], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-system-bar', [_vm._v("\n        Filter results\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.menu = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-treeview', {
    attrs: {
      "dense": "",
      "selectable": "",
      "selection-type": "independent",
      "items": _vm.spaces
    },
    on: {
      "input": _vm.emitSelected
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-248c601d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/SpaceAndLocationPicker.vue
// module id = 1571
// module chunks = 1 3